import script from "./FeedbackModule.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackModule.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackModule.vue?vue&type=style&index=0&id=498e19c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498e19c0"]])

export default __exports__